import { useState } from "react"

export const useLoad = ()=>{
    const [load,setLoad] = useState(false);
    return {
        load,
        setLoad
    }
}